// Utilidades para formatear/parsear montos en pesos chilenos en inputs `type="text"`.
// El usuario escribe `8500000` y ve `8.500.000`. Internamente guardamos el número sin formato.

/** Devuelve el número formateado con puntos cada 3 dígitos (locale es-CL). Vacío si no hay valor. */
export const formatCLP = (value) => {
  if (value === null || value === undefined || value === "") return "";
  const n = parseCLP(value);
  if (!Number.isFinite(n) || n === 0) return value === 0 || value === "0" ? "0" : "";
  return n.toLocaleString("es-CL");
};

/** Convierte un string formateado ("8.500.000" o "$8.500.000") a un número. */
export const parseCLP = (value) => {
  if (typeof value === "number") return value;
  if (!value) return 0;
  const digits = String(value).replace(/[^\d]/g, "");
  if (!digits) return 0;
  return parseInt(digits, 10);
};

/** Handler genérico para inputs CLP que devuelve el valor formateado para mostrar
 *  y guarda el número limpio en el state principal. */
export const onChangeCLP = (e, setNumeric) => {
  const numeric = parseCLP(e.target.value);
  if (typeof setNumeric === "function") setNumeric(numeric);
  return formatCLP(numeric);
};
